<template>
    <div class="card">
        <card>
            <div class="row border-bottom pb-3">
                <h4 slot="header" class="card-title my-auto col-4" >Gestion des informations relatives aux FNC</h4>
                <div class="col-1"></div>
                <input slot="header" type="text" valid="true" placeholder="Recherche" v-model="searchString" class="MySearch form-control col-1 my-auto" @input="search()">
                <div class="col-1"></div>
                <div slot="header" class="btn-group col-4 my-auto" role="group">
                    <a @click="selected = 'product'" :class="selected === 'product' ? 'isSelected starting-radius' : 'unselected starting-radius'" >
                        PRODUIT
                    </a>
                    <a @click="selected = 'supplier'" :class="selected === 'supplier' ? 'isSelected' : 'unselected'" >
                        FOURNISSEUR
                    </a>
                    <a @click="selected = 'contact'" :class="selected === 'contact' ? 'isSelected ending-radius' : 'unselected ending-radius'" >
                        CONTACT
                    </a>
                </div>
                <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="addForm(selected)">
                    <span><i class="fas fa-plus"></i></span>
                </n-button>
                <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="excelExport()">
                    <span><i class="fas fa-file-excel"></i></span>
                </n-button>
                
            </div>
            <ProductList ref="productList" class="mt-5" v-if="selected === 'product'"></ProductList>
            <SupplierList ref="supplierList" class="mt-5" v-if="selected === 'supplier'"></SupplierList>
            <ContactList ref="contactList" class="mt-5" v-if="selected === 'contact'"></ContactList>
        </card>
    </div>
</template>

<script>
import ProductList from '../../Dashboard/Pages/FncAdmin/ProductList.vue'
import SupplierList from '../../Dashboard/Pages/FncAdmin/SupplierList.vue'
import ContactList from '../../Dashboard/Pages/FncAdmin/ContactList.vue'

    export default{
        name: 'FncAdmin',
        components:{
            ProductList,
            SupplierList,
            ContactList,
        },
        data(){ 
            return {
                selected: '',
                searchBuffer: [],
                searchString: ''
            }
        },
        watch: {
            selected: function (newVal, oldVal) {
                if (newVal !== oldVal && oldVal === 'product' ) {
                    this.searchBuffer.splice(0, 1, this.searchString)
                } else if (newVal !== oldVal && oldVal === 'supplier'){
                    this.searchBuffer.splice(1, 1, this.searchString)
                } else if(newVal !== oldVal && oldVal === 'contact'){
                    this.searchBuffer.splice(2, 1, this.searchString)
                }

                if (newVal === 'product' ) {
                    this.searchString = this.searchBuffer[0]  
                } else if (newVal === 'supplier'){
                    this.searchString = this.searchBuffer[1]
                } else if(newVal === 'contact'){
                    this.searchString = this.searchBuffer[2]
                }
            }
        },
        mounted() {
            if (this.$route.params.selected === undefined ){
                this.selected = "product"
            } else {
                this.selected = this.$route.params.selected
            }
        },
        methods: {
            addForm(selected){
                if(selected === 'product'){
                    this.$router.push({ name: 'product form' })
                } else if(selected === 'supplier'){
                    this.$router.push({ name: 'supplier form' })
                } else if(selected === 'contact'){
                    this.$router.push({ name: 'contact form' })
                }
            },

            search(){
                if(this.selected === 'product'){ 
                    this.$refs.productList.search()
                } else if(this.selected === 'supplier'){
                    this.$refs.supplierList.search()
                } else if(this.selected === 'contact'){
                    this.$refs.contactList.search()
                }
            },

            excelExport(){
                if(this.selected === 'product'){
                    this.$refs.productList.excelExport()
                } else if(this.selected === 'supplier'){
                    this.$refs.supplierList.excelExport()
                } else if(this.selected === 'contact'){
                    this.$refs.contactList.excelExport()
                }
            }

            
        },
    }
</script>

<style>


.isSelected {
    display: flex;
    cursor: pointer;
    justify-content: center;
    padding-top: 0.4rem;
    font-weight: 550;
    font-size: 1rem;
    color: white !important;
    width: 50%;
    height: 2.3rem;
    background-color: #f96332;
    border: 1px solid #f96332;
}


.unselected {
    display: flex;
    cursor: pointer;
    justify-content: center;
    padding-top: 0.4rem;
    font-weight: 550;
    font-size: 1rem;
    width: 50%;
    height: 2.3rem;
    color: #f96332 !important;
    background-color: white;
    border: 1px solid #f96332;
} 

.starting-radius {
    border-radius: 10px 0 0 10px;
}

.ending-radius {
    border-radius: 0 10px 10px 0;
}
</style>